module.exports = __webpack_public_path__ + "images/79a74c2bbc624f22a1fb9071785b7c5e.png";